import React from 'react';
import PropTypes from 'prop-types';

const FiletypeDocumentPath = ({ fill = '#195FA6' }) => {
  return (
    <path
      fill={fill}
      d="M20 17h1v.755c0 .137.113.245.252.245h.496c.145 0 .252-.11.252-.245v-1.25a.505.505 0 0 0-.498-.505h-4.004a.494.494 0 0 0-.498.5v1.255c0 .137.113.245.252.245h.496c.145 0 .252-.11.252-.245V17h1v4h-.744a.254.254 0 0 0-.256.252v.496a.25.25 0 0 0 .256.252h2.488a.254.254 0 0 0 .256-.252v-.496a.25.25 0 0 0-.256-.252H20v-4zm5.316-7.319c.382.366.684 1.082.684 1.609v15.084c0 .898-.763 1.626-1.701 1.626H7.701C6.762 28 6 27.272 6 26.374V5.626C6 4.728 6.763 4 7.701 4h10.717c.539 0 1.261.293 1.639.654l5.259 5.027zM10.5 12h7c.269 0 .5-.224.5-.5 0-.268-.224-.5-.5-.5h-7c-.269 0-.5.224-.5.5 0 .268.224.5.5.5zm-.002 4h4.004a.494.494 0 0 0 .498-.5c0-.268-.223-.5-.498-.5h-4.004a.494.494 0 0 0-.498.5c0 .268.223.5.498.5zm0 2h4.004a.494.494 0 0 0 .498-.5c0-.268-.223-.5-.498-.5h-4.004a.494.494 0 0 0-.498.5c0 .268.223.5.498.5zm-.007 2h5.018a.501.501 0 0 0 0-1h-5.018a.501.501 0 0 0 0 1zm.007 2h4.004a.494.494 0 0 0 .498-.5c0-.268-.223-.5-.498-.5h-4.004a.494.494 0 0 0-.498.5c0 .268.223.5.498.5zm.002-8h11c.271 0 .5-.224.5-.5 0-.268-.224-.5-.5-.5h-11c-.271 0-.5.224-.5.5 0 .268.224.5.5.5z"
    />
  );
};

FiletypeDocumentPath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypeDocumentPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-document.jsx